<template>

    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
        <defs>
            <clipPath id="clip-Translate_Light">
                <rect width="48" height="48"/>
            </clipPath>
        </defs>
        <g id="Translate_Light" clip-path="url(#clip-Translate_Light)">
            <g id="Group_39127" data-name="Group 39127">
                <circle id="Ellipse_1069" class="svg-primary-color" data-name="Ellipse 1069" cx="24" cy="24" r="24" transform="translate(0 0)" />
                <path id="Path_4425" class="svg-on-primary-color"  data-name="Path 4425" d="M29,12V9H16a4,4,0,0,0-4,4V35a4,4,0,0,0,4,4h4.2l-.833-1H16a3,3,0,0,1-3-3V30H35v5a3,3,0,0,1-3,3H28.635L27.8,39H32a4,4,0,0,0,4-4V16H33A4,4,0,0,1,29,12ZM22,31v5H19l5,6,5-6H26V31ZM33,15h3L30,9v3A3,3,0,0,0,33,15Z" fill="#fff"/>
                <path id="Path_4387" class="svg-primary-color" data-name="Path 4387" d="M21.747,21.42l.023-.02a13.154,13.154,0,0,0,2.783-4.9h2.2V15H21.5V13.5H20V15H14.75v1.492h8.377a11.776,11.776,0,0,1-2.377,4.02A11.756,11.756,0,0,1,19.017,18h-1.5a13.2,13.2,0,0,0,2.235,3.42l-3.817,3.765L17,26.25l3.75-3.75,2.333,2.333.569-1.53m5.223-5.8h-1.5L24,26.5h1.5l.84-2.25H29.9l.848,2.25h1.5ZM26.91,22.75l1.215-3.25,1.215,3.25Z" fill="#263238"/>
            </g>
        </g>
    </svg>


</template>

<script>

export default {
        name: "translatePdfIcon",
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/translatePdfIcon.vue